import React from "react";
import AccountDetailsScreen from "../../../../../Diathrive/src/containers/AccountDetailsScreen";

const ProvideDetails = (props) => <AccountDetailsScreen {...props} />;

export default ProvideDetails;
